import { legacyBreakpoints } from '@carvana/merch-tailwind/breakpoints';
import styled from 'styled-components';
import {
  minimumMobileHeight,
  minimumNonMobileHeight
} from '@/vdp/Hero/constants';

export const Wrapper = styled.div.attrs({
  className: 'grid overflow-hidden relative'
})`
  height: max(60vh, ${minimumMobileHeight}px);

  @media screen and (min-width: ${legacyBreakpoints.m}px) {
    height: max(
      calc(100vh - var(--header-height)),
      ${minimumNonMobileHeight}px
    );
  }

  :not(&.mobile-capture, &.viewing-interior, .spinner-tour-lock-body &)
    .spinner-controls-layout {
    padding-top: 110px;

    @media screen and (min-width: ${legacyBreakpoints.m}px) {
      padding-top: 140px;
    }
  }

  &.mobile-capture {
    grid-template-rows: auto 1fr;
    height: unset;
  }
`;

export const Container = styled.div.attrs({
  className: 'flex flex-col'
})`
  grid-column: 1;
  grid-row: 1;

  &.is-error {
    margin: 0;
  }

  .mobile-capture & {
    grid-row: 2;
  }

  > * {
    height: 100%;
  }
`;
